export default {
  infoTooltipWrapper: {
    width: '100%',
    height: '100%'
  }
};
